import React, { useEffect, useState } from 'react';
import { Layout, theme, Avatar, Dropdown, Space } from 'antd';
import {
  UserOutlined,
  MoreOutlined,
  LogoutOutlined,
  SettingOutlined,
  CloudUploadOutlined,
  FilePptOutlined
  /* FileExcelOutlined,
  
  FilePdfOutlined, */
  /*  DownOutlined */
} from '@ant-design/icons';
import AuthStore from 'common/authStore';
import './styles.scss';
// import { Logo } from 'assets';
// import { LogoMain } from 'utils/svg';
import { decrypt } from 'utils/functions';

const { Header, Content, Footer } = Layout;

const LayoutComp = ({ children, history, showsubheader = true, isReport = false }) => {
  const usertypestr = localStorage.getItem('usertype');
  const usertype = decrypt(usertypestr);

  const handleLogout = () => {
    localStorage.removeItem('usertype');
    AuthStore.emptyStore();
    window.location.href = '/';
  };
  const gotPage = (pagename) => {
    history.push(pagename);
  };
  const {
    token: { borderRadiusLG }
  } = theme.useToken();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isMobileView = windowWidth <= 650;

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /*   const handledownload = (type) => {
    console.log(type);
  }; */
  const items = [
    {
      label: (
        <div onClick={() => gotPage('/manage_account')}>
          Manage account <FilePptOutlined />
        </div>
      ),
      key: '1',
      icon: <SettingOutlined />
    },
    {
      label: <div onClick={handleLogout}>Logout</div>,
      key: '2',
      icon: <LogoutOutlined />
    }
  ];

  // Add "Manage Questions" and "Hi, User" to the dropdown in mobile view
  if (isMobileView) {
    if (usertype == 1) {
      items.unshift({
        label: (
          <div onClick={() => gotPage('/managequestions')}>
            Manage Questions <CloudUploadOutlined />
          </div>
        ),
        key: '3',
        icon: <CloudUploadOutlined />
      });
    }
    items.unshift({
      label: <div>Hi, {AuthStore.firstName}</div>,
      key: '4',
      icon: <UserOutlined />
    });
  }
  /*  const downloaditems = [
    {
      label: (
        <div onClick={() => handledownload('/manage_account')}>
          Manage account <FilePptOutlined />
        </div>
      ),
      key: '1',
      icon: <SettingOutlined />
    },
    {
      label: <div onClick={() => handledownload('/manage_account')}>Logout</div>,
      key: '2',
      icon: <LogoutOutlined />
    }
  ]; */
  return (
    <Layout className="layoutstyle">
      <Header style={{ display: 'flex', alignItems: 'center', backgroundColor: '#7438F2' }}>
        <div className="demo-logo" onClick={() => gotPage('/')}>
          {/* <img src={Logo} alt="Logo" /> */}
          {/* <LogoMain /> */}
        </div>

        {/* <div className="headerright">
          <span className="material-icons homeicon" onClick={() => gotPage('/')}>
            home
          </span>
          <span className="homeicon separator">|</span> */}
        {/* <Dropdown
            menu={{
              items
            }}
          >
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Hover me
                <DownOutlined />
              </Space>
            </a>
          </Dropdown> */}
        {/* <span className="homeicon separator">|</span> */}
        {/* {usertype == 1 && (
            <>
              <span className="homeicon upload" onClick={() => gotPage('/managequestions')}>
                <CloudUploadOutlined /> Manage Questions
              </span>
              <span className="homeicon separator">|</span>
            </>
          )}
          <div className="userName">
            <Avatar icon={<UserOutlined />} /> Hi, {AuthStore.firstName}
          </div>
          <div className="moreicon">
            <Dropdown
              menu={{
                items
              }}
            >
              <span className="moreiconchild">
                <Space>
                  <MoreOutlined />
                </Space>
              </span>
            </Dropdown>
          </div>
        </div> */}
        <div className="headerright">
          <span className="material-icons homeicon" onClick={() => gotPage('/')}>
            home
          </span>
          <span className="homeicon separator">|</span>

          {/* Hide these items in mobile view */}
          {!isMobileView && usertype == 1 && (
            <>
              <span className="homeicon upload" onClick={() => gotPage('/managequestions')}>
                <CloudUploadOutlined /> Manage Questions
              </span>
              <span className="homeicon separator">|</span>
            </>
          )}
          {!isMobileView && (
            <div className="userName">
              <Avatar icon={<UserOutlined />} /> Hi, {AuthStore.firstName}
            </div>
          )}

          <div className="moreicon">
            <Dropdown menu={{ items: items }}>
              <span className="moreiconchild">
                <Space>
                  <MoreOutlined />
                </Space>
              </span>
            </Dropdown>
          </div>
        </div>
      </Header>
      <Content style={{ padding: '0 50px' }}>
        {showsubheader && <div className="header-bot">Survey Vault</div>}
        <div
          className="contentarea"
          style={{
            minHeight: 280,
            padding: '24px 0',
            borderRadius: borderRadiusLG,
            backgroundColor: '#fff'
          }}
        >
          {children}
        </div>
      </Content>
      <Footer className={`main-footer ${isReport && 'reports-footer'}`}>
        {!isReport && `Copyright ©${new Date().getFullYear()} with Curious Insights`}
      </Footer>
    </Layout>
  );
};

export default LayoutComp;
